// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.v-list-item-title[data-v-61d2d687] {
  font-size: 12px!important;
}
.text-h5[data-v-61d2d687] {
  font-size: 16px !important;
}
.smicon[data-v-61d2d687] {
  font-size: 14px;
  margin-top: 0.75em;
}
.message[data-v-61d2d687],
.message-bubble-column[data-v-61d2d687] {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.message[data-v-61d2d687] {
  margin-bottom: 12px;
}
.v-row + .v-row[data-v-61d2d687] {
    margin-top: 0px!important;
}
.message-bubble-row-human[data-v-61d2d687] {
  justify-content: flex-end;
}
.message-bubble-row-feedback[data-v-61d2d687] {
  justify-content: flex-end;
}
.message-bubble-row-button[data-v-61d2d687] {
  display: none;
}
.message-bubble-row-bot[data-v-61d2d687] {
  max-width: 80vw;
  flex-wrap: nowrap;
  width: 100%;
  box-sizing: border-box;
  padding-right: 10px;
}
.message-date-human[data-v-61d2d687] {
  text-align: right;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}
.message-date-feedback[data-v-61d2d687] {
  text-align: right;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.6);
}
.avatar[data-v-61d2d687] {
  align-self: center;
  border-radius: 50%;
  min-width: calc(2.5em + 1.5vmin);
  min-height: calc(2.5em + 1.5vmin);
  align-self: flex-start;
  margin-right: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background-size: cover !important;
  background-position: center !important;
}
.message-bubble[data-v-61d2d687] {
  border-radius: 24px;
  display: inline-flex;
  font-size: calc(0.95em + 0.25vmin);
  padding: 12px 16px;
  width: -moz-fit-content;
  width: fit-content;
  line-height: 1.5;
  margin: 8px 0;
  max-width: 85%;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  word-break: break-word;
  overflow-wrap: break-word;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.interactive-row[data-v-61d2d687] {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding-top: 8px;
  justify-content: flex-start;
}
.focusable[data-v-61d2d687] {
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  cursor: default;
}
.focusable[data-v-61d2d687]:focus, .focusable[data-v-61d2d687]:hover {
  outline: none;
  transform: translateY(-2px);
}
.message-bot .message-bubble[data-v-61d2d687] {
  background-color: #f0f4f8; 
  color: #2c3e50;
  align-self: flex-start;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  border: none;
}
.message-agent .message-bubble[data-v-61d2d687] {
  background-color: #f0f4f8; 
  color: #2c3e50;
  align-self: flex-start;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  border: none;
}
.message-human .message-bubble[data-v-61d2d687] {
  background: linear-gradient(135deg, #34495e, #2c3e50);
  color: white;
  align-self: flex-end;
  box-shadow: 0 3px 12px rgba(44, 62, 80, 0.4);
  border-radius: 24px;
  padding: 12px 18px;
  margin: 4px 0;
  font-weight: 400;
  letter-spacing: 0.3px;
  position: relative;
  border: none;
}
.message-feedback .message-bubble[data-v-61d2d687] {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
  align-self: flex-end;
  box-shadow: 0 2px 10px rgba(41, 128, 185, 0.3);
  border-radius: 24px;
  border: none;
}
.dialog-state[data-v-61d2d687] {
  display: inline-flex;
  margin-left: 6px;
}
.dialog-state-ok[data-v-61d2d687] {
  color: #2ecc71;
}
.dialog-state-fail[data-v-61d2d687] {
  color: #e74c3c;
}
.play-icon[data-v-61d2d687] {
  font-size: 2em;
  color: #3498db;
}
.feedback-state[data-v-61d2d687] {
  display: inline-flex;
  align-self: center;
  margin-left: 8px;
}
.feedback-icons-positive[data-v-61d2d687]{
  color: rgba(0, 0, 0, 0.5);
  padding: .125em;
  transition: all 0.2s ease;
}
.positiveClick[data-v-61d2d687]{
  color: #2ecc71;
  padding: .125em;
}
.negativeClick[data-v-61d2d687]{
  color: #e74c3c;
  padding: .125em;
}
.feedback-icons-positive[data-v-61d2d687]:hover{
  color: #2ecc71;
  transform: scale(1.1);
}
.feedback-icons-negative[data-v-61d2d687]{
  color: rgba(0, 0, 0, 0.5);
  padding-left: 0.2em;
  transition: all 0.2s ease;
}
.feedback-icons-negative[data-v-61d2d687]:hover{
  color: #e74c3c;
  transform: scale(1.1);
}
.copy-icon[data-v-61d2d687] {
  display: inline-flex;
  align-self: center;
  margin-left: 6px;
  opacity: 0.6;
  transition: all 0.2s ease;
}
.copy-icon[data-v-61d2d687]:hover{
  opacity: 1;
  transform: scale(1.1);
}
.response-card-row[data-v-61d2d687] {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  scrollbar-width: thin;
}
.response-card-row[data-v-61d2d687]::-webkit-scrollbar {
  height: 6px;
}
.response-card-row[data-v-61d2d687]::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.response-card-row[data-v-61d2d687]::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Styling for response buttons */
.response-button[data-v-61d2d687] {
  background-color: #82b1ff !important;
  color: #000000 !important;
  border-radius: 20px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  padding: 0 12px !important;
  height: 32px !important;
  margin: 4px !important;
  transition: all 0.2s ease !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
}
.response-button[data-v-61d2d687]:hover {
  background-color: #6889ff !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-1px) !important;
}
.v-btn--active.response-button[data-v-61d2d687] {
  background-color: #6889ff !important;
}

/* Override default button styles for response options */
.v-btn.v-btn--flat[data-v-61d2d687] {
  background-color: #82b1ff !important;
  color: #000000 !important;
  border-radius: 20px !important;
  margin: 4px !important;
  padding: 0 12px !important;
  height: 32px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  font-size: 0.875rem !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
}
.v-btn.v-btn--flat[data-v-61d2d687]:hover {
  background-color: #6889ff !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-1px) !important;
}
@media (max-width: 480px) {
.response-button[data-v-61d2d687], .v-btn.v-btn--flat[data-v-61d2d687] {
    padding: 0 10px !important;
    height: 30px !important;
    font-size: 0.8rem !important;
    max-width: 150px;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
